
const WHITESPACES_REGEX = new RegExp(/\S/)

// Strings
export const findOccurences = (value, searchString) => {
  let result = searchString.match(new RegExp(value,'g'))
  if(result == null) return 0
    else return result.length;
}

export const getFileName = filePath => {
  let parts = filePath.split('/');
  return parts[parts.length - 1];
};

export const capfirst = text => {
  return text.substr(0, 1).toUpperCase() + text.substr(1);
};

export const formatDate = date => {
  const year = date.getFullYear() % 100;
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  return `${day}.${month}.${year}`;
};


// Array
export const listToString = list => { return list.join('\n') }

export const removeWhitespaces = values => { return values.filter(function(entry){ return WHITESPACES_REGEX.test(entry) }) }

export const removeDuplicates = list => { return [...new Set(list)] }

export const cleanArray = list => removeDuplicates(removeWhitespaces(list))

// Objects